import { fromJS } from 'immutable';
import ACTIONS from '../app.constants';
import { TimeSheetList, TimeSheetReducerActionType } from '../modules/timeSheet/type';
import { Comment } from '../modules/application/types';

export default function timeSheetReducer(state = fromJS({ timeSheet: {} }), action: TimeSheetReducerActionType) {
    switch (action.type) {
        case ACTIONS.TIME_SHEET_LIST.PENDING: {
            return state.setIn(['timeSheetList', 'loading'], true).setIn(['timeSheetList', 'filterLoading'], true);
        }
        case ACTIONS.TIME_SHEET_LIST.SUCCESS:
            let loadedList = state.getIn(['timeSheetList', 'data']) ?? [];
            const timeSheetCount = state.getIn(['timeSheetList', 'timeSheetCount', 'totalTimeSheetCount']);
            const timeSheetList: TimeSheetList = action.payload.data as TimeSheetList;
            if (loadedList && action.skip > 0) {
                loadedList = loadedList.concat(timeSheetList);
            } else {
                loadedList = timeSheetList;
            }

            return state
                .setIn(['timeSheetList', 'data'], loadedList)
                .setIn(['timeSheetList', 'loadMore'], loadedList.length < timeSheetCount)
                .setIn(['timeSheetList', 'loading'], false)
                .setIn(['timeSheetList', 'filterLoading'], false);

        case ACTIONS.TIME_SHEET_LIST.ERROR:
            return state.setIn(['timeSheet', 'loading'], false);

        case ACTIONS.SET_TIME_SHEET_LIST_COUNT.PENDING: {
            return state.setIn(['timeSheetList', 'loading'], false).setIn(['timeSheetList'], []);
        }
        case ACTIONS.SET_TIME_SHEET_LIST_COUNT.SUCCESS: {
            return state.setIn(['timeSheetList', 'timeSheetCount'], action.timeSheetCount);
        }
        case ACTIONS.SET_TIME_SHEET_LIST_COUNT.ERROR: {
            return state.setIn(['timeSheetList', 'loading'], false).setIn(['timeSheetList'], []);
        }

        case ACTIONS.SET_TIMESHEET_FILTERS_SELECTION: {
            return state.setIn(['timeSheetList', 'filterSelections'], action.payload.data);
        }

        case ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE.PENDING: {
            return state.setIn(['timeSheet', 'loading'], true);
        }
        case ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE.SUCCESS: {
            return state.setIn(['timeSheet', 'loading'], false).setIn(['timeSheet', 'data'], action.payload);
        }
        case ACTIONS.OPEN_TIME_SHEET_FOR_SELECTED_DATE.ERROR: {
            return state.setIn(['timeSheet', 'loading'], false);
        }

        case ACTIONS.GET_TIME_SHEET_TYPES.PENDING:
            return state.setIn(['timeSheetType', 'loading'], true);
        case ACTIONS.GET_TIME_SHEET_TYPES.SUCCESS:
            return state
                .setIn(['timeSheetType', 'loading'], false)
                .setIn(['timeSheetType', 'data'], action.payload.data)
                .setIn(['timeSheetType', 'editForm'], action.payload.editForm);

        case ACTIONS.GET_TIME_SHEET_TYPES.ERROR:
            return state.setIn(['timeSheetType', 'loading'], false);

        case ACTIONS.GET_TIME_SHEET_CATEGORIES.PENDING:
            return state.setIn(['timeSheetCategories', 'loading'], true);
        case ACTIONS.GET_TIME_SHEET_CATEGORIES.SUCCESS:
            return state
                .setIn(['timeSheetCategories', 'data'], action.payload)
                .setIn(['timeSheetCategories', 'loading'], false);
        case ACTIONS.GET_TIME_SHEET_CATEGORIES.ERROR:
            return state.setIn(['timeSheetCategories', 'loading'], false);

        case ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES.PENDING:
            return state.setIn(['timeSheetExpenseCategories', 'loading'], true);
        case ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES.SUCCESS:
            return state
                .setIn(['timeSheetExpenseCategories', 'data'], action.payload)
                .setIn(['timeSheetExpenseCategories', 'loading'], false);
        case ACTIONS.GET_TIME_SHEET_EXPENSE_CATEGORIES.ERROR:
            return state.setIn(['timeSheetExpenseCategories', 'loading'], false);

        case ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE.PENDING:
            return state.setIn(['timeSheetAppointments', 'loading'], true);
        case ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE.SUCCESS:
            return state
                .setIn(['timeSheetAppointments', 'data'], action.payload)
                .setIn(['timeSheetAppointments', 'loading'], false);
        case ACTIONS.GET_APPOINTMENT_BY_SELECTED_DATE.ERROR:
            return state.setIn(['timeSheetAppointments', 'loading'], false);

        case ACTIONS.SET_TIME_SHEET_SELECTED_DATE:
            return state.set('selectedDate', action.payload);

        case ACTIONS.GET_TIME_SHEET_COMMENT_LIST.PENDING: {
            return state.setIn(['timeSheetComment', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_TIME_SHEET_COMMENT_LIST.SUCCESS: {
            const timeSheetCommentList = state
                .setIn(['timeSheetComment', 'loading'], false)
                .setIn(['timeSheetComment', 'data'], action.payload);
            return timeSheetCommentList;
        }
        case ACTIONS.GET_TIME_SHEET_COMMENT_LIST.ERROR: {
            return state.setIn(['timeSheetComment', 'loading'], false);
        }

        case ACTIONS.ADD_TIME_SHEET_COMMENT.PENDING: {
            return state.setIn(['timeSheetComment', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.ADD_TIME_SHEET_COMMENT.SUCCESS: {
            const newlyAddedComment = action.payload.data;
            const timeSheetComment: Comment[] = state.getIn(['timeSheetComment', 'data']);
            const newCommentData = timeSheetComment.concat(newlyAddedComment);
            return state
                .setIn(['timeSheetComment', 'loading'], false)
                .setIn(['timeSheetComment', 'data'], newCommentData);
        }
        case ACTIONS.ADD_TIME_SHEET_COMMENT.ERROR: {
            return state
                .setIn(['timeSheetComment', 'loading'], false)
                .setIn(['timeSheetComment', 'error'], action.error);
        }
        case ACTIONS.GET_TIME_SHEET_DETAILS.PENDING: {
            return state.setIn(['timeSheet', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_TIME_SHEET_DETAILS.SUCCESS: {
            return state.setIn(['timeSheet', 'loading'], false).setIn(['timeSheet', 'data'], action.payload);
        }
        case ACTIONS.GET_TIME_SHEET_DETAILS.ERROR: {
            return state.setIn(['timeSheet', 'loading'], false);
        }

        case ACTIONS.SAVE_TIME_SHEET.PENDING: {
            return state.setIn(['timeSheet', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.SAVE_TIME_SHEET.SUCCESS: {
            const timeSheetPayload = action.payload;
            const selectedTimeSheetDetail = state.getIn(['timeSheet', 'data']);

            const updatePayload = {
                ...selectedTimeSheetDetail,
                ...timeSheetPayload,
            };

            return state.setIn(['timeSheet', 'loading'], false).setIn(['timeSheet', 'data'], updatePayload);
        }
        case ACTIONS.SAVE_TIME_SHEET.ERROR: {
            return state.setIn(['timeSheet', 'loading'], false);
        }
        case ACTIONS.DOWNLOAD_TIMESHEET_PACKET.PENDING: {
            return state.setIn(['templates', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.DOWNLOAD_TIMESHEET_PACKET.SUCCESS: {
            return state.setIn(['templates', 'loading'], false);
        }
        case ACTIONS.DOWNLOAD_TIMESHEET_PACKET.ERROR: {
            return state.setIn(['templates', 'loading'], false);
        }

        case ACTIONS.GET_TIMESHEET_SEARCH_FORM.PENDING: {
            return state.setIn(['timeSheetSearchForm', 'loading'], true);
        }

        case ACTIONS.GET_TIMESHEET_SEARCH_FORM.SUCCESS: {
            return state
                .setIn(['timeSheetSearchForm', 'loading'], false)
                .setIn(['timeSheetSearchForm', 'data'], action.data);
        }

        case ACTIONS.GET_TIMESHEET_SEARCH_FORM.ERROR: {
            return state.setIn(['timeSheetSearchForm', 'loading'], false);
        }
    }

    return state;
}
